import React, { useEffect, useState } from "react";
import {
  Grid,
  Avatar,
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
} from "../../components/ui";
import { Add, Delete, Edit, Pageview } from "../../components/icons";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";
import { modalStyle } from "../../style/common";
import { useNavigate } from "react-router-dom";
import { path } from "../../navigation/path";
import FamilyForm from "./components/FamilyForm";

const FamilyList = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [blocks, setBlocks] = useState<any>([]);
  const [id, setId] = useState<any>(null);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    handleGetBlocks();
    setId(null);
  };

  const handleGetBlocks = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/family`);
      if (resp?.status === 200) {
        setBlocks(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };
  const handleDelete = async (id: any) => {
    try {
      const resp: any = await axiosInstance.delete(`/api/family/${id}`);
      if (resp?.status === 200) {
        handleGetBlocks();

        toast.success("Deleted Successfully");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handleGetBlocks();
  }, []);
  return (
    <div>
      <Grid container p={2} px={{ md: 10, xs: 5 }}>
        <Grid size={12}>
          <Button onClick={handleOpen} sx={{ textTransform: "none" }}>
            <Typography fontSize={20} fontWeight={500} color="#111827">
              Family
              <IconButton onClick={handleOpen}>
                <Add sx={{ color: "#111827" }} />
              </IconButton>
            </Typography>
          </Button>
        </Grid>
        <Grid
          size={12}
          container
          mt={2}
          py={1}
          bgcolor={"#111827"}
          borderRadius={1}
          color={"whitesmoke"}
        >
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Sl no
            </Typography>
          </Grid>
          <Grid size={10}>
            <Typography fontSize={17} fontWeight={500} align="left">
              Family
            </Typography>
          </Grid>
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Action
            </Typography>
          </Grid>
        </Grid>
        {blocks?.map((item: any, index: any) => (
          <Grid size={12} container borderBottom={"1px solid #111827"} py={2}>
            <Grid size={1}>
              <Typography fontSize={17} align="center">
                {" "}
                {index + 1}
              </Typography>
            </Grid>
            <Grid size={10}>
              <Box display={"flex"}>
                <Avatar
                  sx={{ height: 80, width: 80, mx: 2 }}
                  src={`http://localhost:3070/${item?.head?.image_path}`}
                />{" "}
                <Box>
                  <Typography fontSize={17} fontWeight={600}>
                    {item?.head?.name}
                  </Typography>
                  <Typography fontSize={16}>
                    {item?.head?.appartments?.map((apt: any, ind: any) => (
                      <div color="grey" key={ind}>
                        {apt?.appartment_name}
                      </div>
                    ))}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid
              size={1}
              sx={
                item?.is_request_send && {
                  pointerEvents: "none",
                  opacity: 0.6,
                }
              }
            >
              <Typography fontSize={17} align="center">
                <IconButton
                  onClick={() => {
                    setId(item?.id);
                    handleOpen();
                    navigate(path.FAMILY_TREE_VIEW, { state: { id: item?.id } });
                  }}
                >
                  <Pageview sx={{ color: "#111827" }} />
                </IconButton>
                <IconButton onClick={() => handleDelete(item?.id)}>
                  <Delete sx={{ color: "#111827" }} />
                </IconButton>
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Modal onClose={handleClose} open={open}>
        <Box sx={modalStyle}>
          <FamilyForm onClose={handleClose} id={id} />
        </Box>
      </Modal>
    </div>
  );
};

export default FamilyList;
